import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface UIState {
  [key: string]: any; // Stores UI states per component
}

@Injectable({
  providedIn: 'root'
})
export class UIStateService {
  private state: UIState = {};
  private stateSubject = new BehaviorSubject<UIState>({});

  /** Get saved state for a component */
  getState(key: string): any {
    return this.state[key] || null;
  }

  /** Save component state */
  saveState(key: string, data: any) {
    this.state[key] = data;
    sessionStorage.setItem('UIState', JSON.stringify(this.state)); // Persist across refresh
    this.stateSubject.next(this.state);
  }

  /** Restore UI State after reload */
  restoreState(): void {
    const savedState = sessionStorage.getItem('UIState');
    this.state = savedState ? JSON.parse(savedState) : {};
    this.stateSubject.next(this.state);
  }

  /** Clear state for a closed tab */
  resetState(key: string) {
    delete this.state[key];
    sessionStorage.setItem('UIState', JSON.stringify(this.state));
    this.stateSubject.next(this.state);
  }
}
